import { render, staticRenderFns } from "./vehicle-details.vue?vue&type=template&id=fb9f465a&scoped=true&"
import script from "./vehicle-details.vue?vue&type=script&lang=js&"
export * from "./vehicle-details.vue?vue&type=script&lang=js&"
import style0 from "./vehicle-details.vue?vue&type=style&index=0&id=fb9f465a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9f465a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VImg,VSimpleTable})
